import { trackEvent } from '@/shared/track';
import { InitialPanelInput } from '../ui';
import { DiscoveryTemplateSuggestions } from '../ui/discovery-templates';
import { useDiscoveryStore } from '../stores/discovery-store';
import type { DiscoverySession } from '@/entities/discovery';
import { useAtomValue } from 'jotai';
import { searchCreatorPendingAtom } from '../stores/mutation-atom';
import { useAnalyzeDiscoveryPrompt } from '../hooks/use-analyze-discovery-prompt';

export const DiscoveryInitialPanel = ({ session }: { session: DiscoverySession }) => {
  const { prompt, setPrompt, setViewState } = useDiscoveryStore();
  const searchPending = useAtomValue(searchCreatorPendingAtom);
  const submitMutation = useAnalyzeDiscoveryPrompt();

  const onPromptSubmit = async (prompt: string, source: 'free_text' | 'template' = 'free_text') => {
    trackEvent('Creator', 'submit_prompt', {
      prompt,
      source,
    });
    setViewState('chat');
    await submitMutation.mutateAsync({
      discoverySessionId: session.session_id,
      request: {
        message: prompt,
      },
    });
  };

  return (
    <div className="flex w-full flex-col items-center gap-10">
      {/* Header Section */}
      <div className="flex flex-col items-center gap-3">
        <h1 className="text-primary text-3xl font-bold">Discover creators</h1>
        <p className="text-muted-foreground text-center text-sm">
          Describe the content style, filming setup, or creator characteristics you're looking for
        </p>
      </div>

      {/* Input Section */}
      <div className="flex w-full max-w-190 flex-col items-center gap-6">
        <InitialPanelInput
          value={prompt}
          onValueChange={setPrompt}
          onSubmit={onPromptSubmit}
          disabled={searchPending}
        />
        <DiscoveryTemplateSuggestions onSelect={onPromptSubmit} />
      </div>
    </div>
  );
};
